import * as React from 'react';
import { IntlProvider } from 'react-intl';

import { useSettingsStore } from '@/store/useSettingsStore';
import { flattenMessages } from '@/utils';

import ar from '../locales/ar.json';
import en from '../locales/en.json';

const messagesMap = { en, ar };

export const LangProvider = ({ children }: { children: React.ReactNode }) => {
  const language = useSettingsStore((s) => s.settings.language);

  const messages = React.useMemo(
    () =>
      flattenMessages(
        messagesMap[language as keyof typeof messagesMap] || messagesMap['en']
      ),
    [language]
  );

  return (
    <IntlProvider
      locale={
        messagesMap[language as keyof typeof messagesMap] ? language : 'en'
      }
      messages={messages}
      defaultLocale="en"
    >
      {children}
    </IntlProvider>
  );
};
